import React from 'react';
import { useTranslation } from 'react-i18next';

import { BaseModal } from '@/libs/shared/ui';

type Props = {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
};

export const MyAccountModal = ({ open, onClose, children }: Readonly<Props>) => {
  const { t } = useTranslation();

  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title={t('userMenu.myAccount')}
      variant="positioned"
      maxWidth="600px"
    >
      {children}
    </BaseModal>
  );
};
